"use client";
import React from "react";
import Image from "next/image";
import PreferredVendorBadge from "@/Helper/images/new/preferred_vendor_badge_white.svg";
import client_logo1 from "@/Helper/images/new/client_logo/adient-logo-white.png";
import client_logo2 from "@/Helper/images/new/client_logo/Aero Simulation Inc logo-white.png";
import client_logo3 from "@/Helper/images/new/client_logo/ATS-logo-white.png";
import client_logo4 from "@/Helper/images/new/client_logo/BAE-Systems-logo-white.png";
import client_logo5 from "@/Helper/images/new/client_logo/Beechcraft-logo-white.png";
import client_logo6 from "@/Helper/images/new/client_logo/bell-helicopter-logo-white.png";
import client_logo7 from "@/Helper/images/new/client_logo/Bettcher-Logo-white.png";
import client_logo8 from "@/Helper/images/new/client_logo/brose-logo-white.png";
import client_logo9 from "@/Helper/images/new/client_logo/Certainteed-Logo-white.png";
import client_logo10 from "@/Helper/images/new/client_logo/Cessna-logo-white.png";
import client_logo11 from "@/Helper/images/new/client_logo/depuy-synthes-logo-white.png";
// import client_logo12 from "@/Helper/images/new/client_logo/Shukla Medical Logo-white.png";
// import client_logo13 from "@/Helper/images/new/client_logo/smith-nephew logo-white.png";
// import client_logo14 from "@/Helper/images/new/client_logo/Stryker logo-white.png";
// import client_logo15 from "@/Helper/images/new/client_logo/zimmer-biomet logo-white.png";
import client_logo16 from "@/Helper/images/new/client_logo/GE-Aircraft-Engines-logo-white.png";
// import client_logo17 from "@/Helper/images/new/client_logo/goodrich logo-white.png";
import client_logo18 from "@/Helper/images/new/client_logo/gulfstream-logo-white.png";
import client_logo19 from "@/Helper/images/new/client_logo/Honeywell-logo-white.png";
import client_logo20 from "@/Helper/images/new/client_logo/Kimberly-Clark_logo-white.png";
import client_logo21 from "@/Helper/images/new/client_logo/lear-logo-white.png";
import client_logo22 from "@/Helper/images/new/client_logo/liebherr-logo-white.png";
import client_logo23 from "@/Helper/images/new/client_logo/Lockheed_Martin-logo-white.png";
import client_logo24 from "@/Helper/images/new/client_logo/mcmaster-carr-logo-white.png";
import client_logo25 from "@/Helper/images/new/client_logo/Parker_Hannifin-logo-white.png";
// import client_logo26 from "@/Helper/images/new/client_logo/piper-aircraft logo-white.png";
// import client_logo27 from "@/Helper/images/new/client_logo/roll-rite logo-white.png";
// import client_logo28 from "@/Helper/images/new/client_logo/Safran logo-white.png";
// import client_logo29 from "@/Helper/images/new/client_logo/TE_Connectivity_logo-white.png";
// import client_logo30 from "@/Helper/images/new/client_logo/utc-aerospace-systems-logo-white.png";

const clientLogos = [
  { src: client_logo1, alt: "Adient company logo" },
  { src: client_logo2, alt: "Aero Simulation Inc. company logo" },
  { src: client_logo3, alt: "ATS company logo" },
  { src: client_logo4, alt: "BAE Systems company logo" },
  { src: client_logo5, alt: "Beechcraft company logo" },
  { src: client_logo6, alt: "Bell Helicopter company logo" },
  { src: client_logo7, alt: "Bettcher company logo" },
  { src: client_logo8, alt: "Brose company logo" },
  { src: client_logo9, alt: "CertainTeed company logo" },
  { src: client_logo10, alt: "Cessna company logo" },
  { src: client_logo11, alt: "DePuy Synthes company logo" },
  // { src: client_logo12, alt: "Shukla Medical company logo" },
  // { src: client_logo13, alt: "Smith & Nephew company logo" },
  // { src: client_logo14, alt: "Stryker company logo" },
  // { src: client_logo15, alt: "Zimmer Biomet company logo" },
  { src: client_logo16, alt: "GE Aircraft Engines company logo" },
  // { src: client_logo17, alt: "Goodrich company logo" },
  { src: client_logo18, alt: "Gulfstream company logo" },
  { src: client_logo19, alt: "Honeywell company logo" },
  { src: client_logo20, alt: "Kimberly-Clark company logo" },
  { src: client_logo21, alt: "Lear Corporation company logo" },
  { src: client_logo22, alt: "Liebherr company logo" },
  { src: client_logo23, alt: "Lockheed Martin company logo" },
  { src: client_logo24, alt: "McMaster-Carr company logo" },
  { src: client_logo25, alt: "Parker Hannifin company logo" },
  // { src: client_logo26, alt: "Piper Aircraft company logo" },
  // { src: client_logo27, alt: "Roll-Rite company logo" },
  // { src: client_logo28, alt: "Safran company logo" },
  // { src: client_logo29, alt: "TE Connectivity company logo" },
  // { src: client_logo30, alt: "UTC Aerospace Systems company logo" },
];

const HomeClientsLogo = () => {
  return (
    <div className="client_logosection">
      <div className="container">
        <div className="client_logoinner">
          <div className="client_logoleft">
            <Image
              className="lazy-image"
              src={PreferredVendorBadge}
              alt="Preferred vendor badge"
              width={250}
              height={250}
            />
          </div>

          <div className="client_logoright">
            <div className="client_logrightinner">
              {clientLogos.map((logo, index) => (
                <div className="lient_logrightlist" key={index}>
                  <Image
                    className="lazy-image"
                    src={logo.src}
                    alt={logo.alt}
                     width={125}
                    height={50}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeClientsLogo;
